module.exports = __webpack_public_path__ + "static/media/about2.01166b2e.jpg";